import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";

export const DataFreshness = ({ version, onRefresh, prefix }) => {
  const [data, setData] = useState(null), [error, setError] = useState(false), [busy, setBusy] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setBusy(true);
    api.get("/v3/data-freshness", { signal: controller.signal })
      .then(r => { setData(r.data); setError(false); })
      .catch(e => { if (e.code !== "ERR_CANCELED") setError(true); })
      .finally(() => { if (!controller.signal.aborted) setBusy(false); });
    return () => controller.abort();
  }, [version]);
  return <section className="source-freshness" data-testid={`${prefix}-data-freshness`} aria-busy={busy}>
    <div className="min-w-0">
      <div className="ceo-label">LMS applications · live read-only</div>
      <div className="text-sm font-semibold mt-1" data-testid={`${prefix}-latest-application`}>
        {error ? "Freshness check unavailable" : !data ? "Checking source…" : data.applications.latest_number ? <Link data-testid={`${prefix}-latest-application-link`} className="rf-link" to={`/pipeline3?source=historical&q=${encodeURIComponent(data.applications.latest_number)}`}>
          {data.applications.latest_number} · {data.applications.latest_date}
        </Link> : "No applications available"}
      </div>
    </div>
    <div className="min-w-0">
      <div className="ceo-label">Loan-book snapshot · historical</div>
      <div className="text-sm font-semibold mt-1" data-testid={`${prefix}-latest-snapshot`}>{error ? "Not verified" : data?.loanbook.latest_snapshot || "Not available"}{!error && data?.loanbook.stale ? " · newer snapshot not available" : ""}</div>
    </div>
    <div className="flex items-center flex-wrap gap-3 min-w-0">
      <span className="text-xs text-slate-500" data-testid={`${prefix}-checked-at`}>{error ? "Previously displayed figures are not freshly verified." : data ? `Checked ${new Date(data.checked_at).toLocaleTimeString("en-IN")}` : ""}</span>
      <button type="button" data-testid={`${prefix}-refresh-data`} disabled={busy} onClick={onRefresh} className="inline-flex items-center gap-2 border border-slate-300 px-3 py-2 text-xs font-semibold hover:bg-white transition-colors disabled:opacity-50"><RefreshCw size={14} className={busy ? "animate-spin" : ""} />{error ? "Retry" : "Refresh"}</button>
    </div>
  </section>;
};